import React from "react";
import { LinearProgress, LinearProgressProps, SxProps, Theme } from "@mui/material";

export type WcLinearProgressProps = LinearProgressProps & {
  sx?: SxProps<Theme>;
};

export const WcLinearProgress = (props: WcLinearProgressProps) => <LinearProgress sx={props.sx} {...props} />;

export default WcLinearProgress;
